<style>
.dropdown-item {
  padding: 0.438rem 0.65rem;
  z-index: -1 !important;
}

.map_btn {
  width: auto;
}

.navbar {
  padding: 0.1rem 1rem;
}

.dropdown-toggle::after {
  display: contents;
}

.lang_icon {
  height: 25px;
  width: 25px !important;
}
</style>
<template>
  <b-navbar toggleable="lg" :variant="getLayoutNavbarBg()" class="layout-navbar align-items-lg-center bg-success-darker container-p-x">
    <b-navbar-brand to="/" class="app-brand demo d-lg-none py-0 mr-4">
      <span class="app-brand-logo demo">
        <img v-if="$store.getters.generic.settings && $store.getters.generic.settings.dashboard_logo" :src="backend_url + $store.getters.generic.settings.dashboard_logo" alt="img">
      </span>
    </b-navbar-brand>
    <b-navbar-nav class="layout-sidenav-toggle d-lg-none align-items-lg-center mr-auto" v-if="sidenavToggle">
      <a class="nav-item nav-link px-0 mr-lg-4" href="javascript:void(0)" @click="toggleSidenav">
        <i class="ion ion-md-menu text-large align-middle" />
      </a>
    </b-navbar-nav>
    <b-navbar-toggle target="app-layout-navbar"></b-navbar-toggle>
    <b-collapse is-nav id="app-layout-navbar">
      <hr class="d-lg-none w-100 my-2">
      <!-- <b-navbar-brand to="/" class="app-brand demo d-lg-none py-0 mr-4">
        <span class="app-brand-logo demo">
          <img v-if="setting && setting.dashboard_logo" :src="backend_url + setting.dashboard_logo" alt="img">

        </span>

      </b-navbar-brand> -->
      <div class="col-md-2" v-if="fleets.length > 0">
        <multiselect v-model="selected_fleet" :options="fleets" :allow-empty="false" :multiple="false" :close-on-select="true" :clear-on-select="true" :preserve-search="true" :clearable="false" :placeholder="$t('choose_fleet')" label="label"
          track-by="value" :showLabels="false" :maxHeight="200" class="select-bg" @input="refresh_fleet()">
          <span slot="noResult">{{ $t('no_result') }}</span>
          <span slot="noOptions">{{ $t('no_options') }}</span>
        </multiselect>
        <!-- <v-select
          v-model="selected_fleet"
          :options="fleets"
          @change="refresh_fleet()"
          :clearable="false"
        ></v-select> -->
      </div>
      <b-navbar-nav class="align-items-lg-center ml-auto">
        <!--<b-dd-item v-for="item in menu_list" :to="item.path" :key="item.title">-->
        <!--<i :class="item.icon"></i> &nbsp;-->
        <!--{{ item.title }}-->
        <!--</b-dd-item>-->
        <b-nav tabs class="tabs-alt">
          <b-nav-item class="map_btn" :to="{ name: 'map'}" :active="$route.name == 'map'">
            <i class="ion ion-ios-map"></i> &nbsp;
            {{ $t("map") }}
          </b-nav-item>
          <div v-for="item in menu_list" :key="item.title">
            <b-nav-item :active="item.name === $route.name" :to="item.path"><i :class="item.icon"></i> &nbsp;{{ $t(item.title) }}</b-nav-item>
            <!--<b-nav-item-dropdown v-if="item.subMenu" :text="item.title" :right="isRTL">-->
            <!--<b-dd-item v-for="subItem in item.subMenu" :active="item.name === $route.name" :to="item.path" :key="subItem.title">{{ subItem.title }}</b-dd-item>-->
            <!--</b-nav-item-dropdown>-->
          </div>
        </b-nav>

        <template v-if="$route.name == 'map'">
          <div class="nav-item d-none d-lg-block text-big font-weight-light line-height-1 opacity-25">|</div>
          <b-nav-item-dropdown right>
            <template slot="button-content">
              <span class="d-inline-flex flex-lg-row-reverse align-items-center align-middle">
                <i class="fa fa-bell"></i>
              </span>
            </template>
            <div class="row">
              <div class="col">
                <div class="bg-primary text-center text-white font-weight-bold mt-n1 p-1">
                  {{$t('notifications')}}
                </div>
                <div class="pull-right mt-n4 mr-3 text-white" style="cursor: pointer" @click="clear_notification_list()">
                  <i class="fa fa-trash"></i>
                </div>
              </div>
            </div>
            <perfect-scrollbar style="height: 234px">
            <b-list-group style="height:250px;  width: 500px;">
              <template v-for="data in notification_list.slice(-50).reverse()">
                <b-list-group-item class="media d-flex align-items-center">
                  <i class="fa fa-bell d-block ui-w-40 rounded-circle" style="font-size: 200%;"></i>
                  <div class="media-body ml-3">
                    <div class="text-dark line-height-condenced">{{data.title}}</div>
                    <div class="text-light small mt-1">{{data.text}}</div>
                  </div>
                </b-list-group-item>
              </template>
            </b-list-group>
          </perfect-scrollbar>
            <router-link :to="'/alarm/alarm-tracking'" :exact="true" class="d-block text-center text-light small p-2 my-1">{{$t('show_all_notifications')}}</router-link>
          </b-nav-item-dropdown>
        </template>

        <div class="nav-item d-none d-lg-block text-big font-weight-light line-height-1 opacity-25 mr-3">|</div>
        <b-nav-item-dropdown class="demo-navbar-user">
          <template slot="button-content">
            <span class="d-inline-flex flex-lg-row-reverse align-items-center align-middle">
              <img :src="langFlag" alt class="d-block rounded-circle lang_icon">
            </span>
          </template>
          <b-dd-item @click="changeLanguage('tr')"><img :src="`${publicUrl}img/flags/tr.png`" width="25px"> &nbsp; Türkçe </b-dd-item>
          <b-dd-item @click="changeLanguage('en')"><img :src="`${publicUrl}img/flags/en.png`" width="25px"> &nbsp; English </b-dd-item>
          <b-dd-item @click="changeLanguage('de')"><img :src="`${publicUrl}img/flags/de.png`" width="25px"> &nbsp; Deutsche </b-dd-item>
          <b-dd-item @click="changeLanguage('ar')"><img :src="`${publicUrl}img/flags/ar.png`" width="25px"> &nbsp; عربى </b-dd-item>
          <!--<b-dd-item @click="changeLanguage('ru')"><img :src="`${publicUrl}img/flags/ru.png`" width="25px"> &nbsp; Pусский </b-dd-item>-->
          <!--<b-dd-item @click="changeLanguage('ja')"><img :src="`${publicUrl}img/flags/ja.png`" width="25px"> &nbsp; 日本の </b-dd-item>-->
        </b-nav-item-dropdown>
        <b-nav-item-dropdown :right="!isRTL" class="demo-navbar-user">
          <template slot="button-content">
            <span class="d-inline-flex flex-lg-row-reverse align-items-center align-middle">
              <img :src="`${publicUrl}img/avatars/1.png`" alt class="d-block ui-w-30 rounded-circle">
              <span class="px-1 mr-lg-2 ml-2 ml-lg-0">{{ user.profile.first_name + ' ' + user.profile.last_name }}</span>
            </span>
          </template>
          <b-dd-item :active="$route.name === 'account-settings'" :to="{ name: 'account-settings' }"><i class="ion ion-md-settings text-lightest"></i> &nbsp;
            {{ $t('settings') }}
          </b-dd-item>
          <b-dd-item v-if="showVehicleSettings" @click="showVehicleSettingsModal"><i class="fas fa-car"></i> &nbsp;
            {{ $t('map_settings') }}
          </b-dd-item>
          <!-- <b-dd-item><i class="ion ion-ios-mail text-lightest"></i> &nbsp;
            {{$t('messages')}}
          </b-dd-item> -->
          <b-dd-item :active="$route.name === 'request-support'" :to="{ name: 'request-support' }"><i class="ion ion-md-mail text-lightest"></i> &nbsp;
            {{ $t('request_support') }}
          </b-dd-item>
          <b-dd-item v-on:click="logout()">
            <i class="ion ion-ios-log-out text-danger"></i> &nbsp;
            {{ $t('sign_out') }}
          </b-dd-item>
        </b-nav-item-dropdown>
      </b-navbar-nav>
    </b-collapse>

    <!-- Vehicle Settings Modal -->
    <b-modal ref="vehicle_settings_modal" name="car-settings" id="car-settings-modal" :size="'xl'" hide-footer>
      <div slot="modal-title">
        {{ $t('car_settings') }}
      </div>

      <b-card>
        <div class="row mb-2">
          <div class="col-md-2 mb-5" v-for="(row, index) in tempVehicleSettings" :key="index">
            <b-checkbox v-model="row.value" @change="changeVehicleSettings(row.field)">{{ row.label }}</b-checkbox>
          </div>
        </div>
        <b-btn variant="btn btn-danger pull-right ml-1" @click="cancelVehicleSettings">
          <i class="fas fa-times mr-1"></i>
          {{ $t('cancel') }}
        </b-btn>
        <b-btn variant="btn btn-success pull-right" @click="saveVehicleSettings">
          <i class="fas fa-save mr-1"></i>
          {{ $t('save') }}
        </b-btn>
      </b-card>
      <custom-loading :isLoading="isSettingsLoading" :fullPage="true"></custom-loading>
    </b-modal>
    <!-- Vehicle Settings Modal -->
    <map-settings v-if="showVehicleSettings" :modalShow="showsettings" @close="close"></map-settings>

  </b-navbar>
</template>

<script>
import { Sidenav, SidenavLink, SidenavRouterLink, SidenavMenu, SidenavHeader, SidenavBlock, SidenavDivider } from '@/vendor/libs/sidenav'
import auth from '@/services/AuthService'
import router from '@/router'
import { mapGetters, mapActions } from 'vuex'
import VSelect from 'vue-select'
import Api from '@/services/Api'
import store from '@/store'
import LayoutSidenav from './LayoutSidenav'
import customLoading from '@/components/widgets/customLoading'
import { getSystemSettings } from '../../utils/index'
import Multiselect from 'vue-multiselect'
import MapSettingsVue from '../widgets/MapSettings.vue'
import PerfectScrollbar from '@/vendor/libs/perfect-scrollbar/PerfectScrollbar'


export default {
  name: 'app-layout-navbar',
  data() {
    return {
      showVehicleSettings: false,
      showsettings: false,
      vehicleSettings: [
        {
          field: 'plate',
          value: true
        },
        {
          field: 'speed',
          value: false
        },
        {
          field: 'driver_name',
          value: false
        },
        {
          field: 'daily_km',
          value: false
        },
        {
          label: this.$t('temp_sensor_1'),
          field: 'temp_sensor_1',
          value: false
        },
        {
          label: this.$t('temp_sensor_2'),
          field: 'temp_sensor_2',
          value: false
        },
        {
          label: this.$t('temp_sensor_3'),
          field: 'temp_sensor_3',
          value: false
        },
        {
          label: this.$t('temp_sensor_4'),
          field: 'temp_sensor_4',
          value: false
        }
      ],
      tempVehicleSettings: [
        {
          label: this.$t('plate'),
          field: 'plate',
          value: false
        },
        {
          label: this.$t('speed'),
          field: 'speed',
          value: false
        },
        {
          label: this.$t('driver'),
          field: 'driver_name',
          value: false
        },
        {
          label: this.$t('daily_mileage'),
          field: 'daily_km',
          value: false
        },
        {
          label: this.$t('temp_sensor_1'),
          field: 'temp_sensor_1',
          value: false
        },
        {
          label: this.$t('temp_sensor_2'),
          field: 'temp_sensor_2',
          value: false
        },
        {
          label: this.$t('temp_sensor_3'),
          field: 'temp_sensor_3',
          value: false
        },
        {
          label: this.$t('temp_sensor_4'),
          field: 'temp_sensor_4',
          value: false
        }

      ],
      isSettingsLoading: false,
      backend_url: store.getters.DOMAIN,
      setting: null,
      current_page: '',
      menu_list: [],
      langFlag: '/img/flags/' + this.$store.state.lang.lang + '.png',
      fleets: this.$store.state.fleet && this.$store.state.fleet.fleets ? this.$store.state.fleet.fleets : [],
    }
  },
  props: {
    sidenavToggle: {
      type: Boolean,
      default: true
    },
  },

  components: {
    /* eslint-disable vue/no-unused-components */
    Sidenav,
    SidenavLink,
    SidenavRouterLink,
    SidenavMenu,
    SidenavHeader,
    SidenavBlock,
    SidenavDivider,
    Multiselect,
    'v-select': VSelect,
    appLayoutSidenav: LayoutSidenav,
    'custom-loading': customLoading,
    'map-settings': MapSettingsVue,
    PerfectScrollbar

    /* eslint-enable vue/no-unused-components */
  },
  created() {
    this.changeSideMenu()
  },
  methods: {
    ...mapActions([
      'clear_notification_list',
      
    ]),
    changeVehicleSettings(field) {
      this.tempVehicleSettings.map(row => {
        if (row.field === field) {
          row.value = !row.value
        }
        return row
      })
    },
    saveVehicleSettings() {
      this.vehicleSettings.map(row => {
        row.value = this.tempVehicleSettings.find(v => v.field === row.field).value
        return row
      })
      this.setTagSettings()
    },
    cancelVehicleSettings() {
      this.tempVehicleSettings.map(row => {
        row.value = this.vehicleSettings.find(v => v.field === row.field).value
        return row
      })
      this.$refs.vehicle_settings_modal.hide()
    },
    showVehicleSettingsModal() {
      // this.$refs.vehicle_settings_modal.show()
      this.showsettings = true
    },
    close() {
      this.showsettings = false
      this.modal_show = false
    },
    setTagSettings() {
      let tagSettings = {}
      for (let i = 0; i < this.vehicleSettings.length; i++) {
        const row = this.vehicleSettings[i]
        tagSettings[row.field] = row.value
      }
      let params = {
        tag_settings: tagSettings
      }
      let self = this

      this.isLoading = true
      Api.post(this, 'ats/user-tag-settings/update', params)
        .then(response => {
          if (response.status) {
            this.$swal({
              type: 'success',
              title: self.$t('swal_warning_attention'),
              text: self.$t('swal_settings_updated')
            })

            this.$store.commit('set_tag_settings', tagSettings)
            this.$refs.vehicle_settings_modal.hide()
          } else {
            this.$swal({
              type: 'error',
              title: self.$t('swal_warning_attention'),
              text: self.$t('swal_settings_cant_update')
            })
          }
        })
        .catch(e => {
          console.log('e', e)
          self.$swal({
            type: 'error',
            title: self.$t('swal_warning_attention'),
            text: self.$t('swal_settings_cant_update')
          })
        })
      this.isLoading = false
    },
    // getTagSettings () {
    //   this.isLoading = true
    //   Api.get('ats/user-tag-settings')
    //     .then(response => {
    //       if (response && response.data && response.data.status) {
    //         this.vehicleSettings.map(row => {
    //           row.value = !!response.data.data[row.field]
    //           return row
    //         })
    //         this.tempVehicleSettings.map(row => {
    //           row.value = !!response.data.data[row.field]
    //           return row
    //         })
    //       }
    //     })
    //     .catch(e => {
    //       console.log('Araç ayarlari getirilemedi!', e)
    //     })
    //   this.isLoading = false
    // },

    isMenuActive(url) {
      return this.$route.path.indexOf(url) === 0
    },
    isMenuOpen(url) {
      return this.$route.path.indexOf(url) === 0 && this.orientation !== 'horizontal'
    },
    toggleSidenav() {
      this.layoutHelpers.toggleCollapsed()
    },
    logout() {
      auth.logout(this)
    },
    getLayoutNavbarBg() {
      return this.layoutNavbarBg
    },
    refresh_fleet() {
      let self = this
      let selected_fleet = this.$store.state.fleet.selected_fleet

      Api.get('ats/get_vehicles_list', { fleet_id: selected_fleet.value }).then(response => {
        if (response.status) {
          let vehicles = response.data.data ? response.data.data : []
          self.$store.commit('setAllVehicles', vehicles)
          localStorage.setItem('vehicles', JSON.stringify(vehicles))
        }
      })
      Api.get('ats/vehicle_group_list?fleet_id=' + selected_fleet.value).then(response => {
        if (response.status) {
          self.$store.commit('setAllGroups', response.data)
          localStorage.setItem('vgroups', JSON.stringify(response.data))
        }
      })
      Api.post(this, 'ats/get_all_alarms', { fleet_id: selected_fleet.value }).then(response => {
        this.$store.commit('setAlarmUtils', ['alarms', response.alert_types])
        localStorage.setItem('alarms', JSON.stringify(response.alert_types))
        this.$store.commit('setAlarmUtils', ['notifications', response.replay_types])
        localStorage.setItem('notifications', JSON.stringify(response.replay_types))
      })
      Api.get('ats/get_vehicle_types').then(response => {
        if (response.status) {
          self.$store.commit('setVehicleTypes', response.data)
          localStorage.setItem('vehicleTypes', JSON.stringify(response.data))
        }
      })
    },
    changeSideMenu() {
      this.menu_list = router.options.routes.filter(item => {
        if (item.navbar && item.meta && this.$store.getters.permissions.includes(item.meta.perm)) {
          return item
        }
      })
    },
    changeLanguage(language) {
      this.$i18n.locale = language
      this.$store.commit('change_lang', language)
      localStorage.setItem('lang', language)
      this.langFlag = '/img/flags/' + this.$store.state.lang.lang + '.png'
      Api.put(this, 'ats/set-user-language', { language: language })
        .then(response => {
          if (response.status !== true) {
            console.log(`Set user language failed: `, response)
          }
        })
        .catch(e => {
          console.log(`User language error: `, e)
        })

    },

  },
  computed: {
    ...mapGetters([
      'user',
      'notification_list',
      'vehicles'
    ]),
    selected_fleet: {
      get() {
        this.fleets = this.$store.state.fleet.fleets
        return this.$store.state.fleet.selected_fleet
      },
      set(val) {
        if (val !== this.selected_fleet) {
          this.$store.dispatch('selected_fleet', val)
          Api.post(this, 'auth/get_user_perms', { fl: val['value'] }).then(response => {
            this.$store.commit('setPermission', response)
            this.$store.dispatch('selected_fleet', val)
            window.location.reload(true)
          })
        }
      }
    }
  },
  watch: {
    $route(to, from) {
      this.changeSideMenu()
    },
    showVehicleSettings() {
      this.showVehicleSettings = this.$route.name == 'map'
    },
    fleets() {
      return this.$store.state.fleet.fleets
    }
  },
  mounted() {
    this.refresh_fleet()
    getSystemSettings()
    this.vehicleSettings.map(row => {
      row.value = this.$store.state.user.tag_settings[row.field] ? true : false
      return row
    })
    this.tempVehicleSettings.map(row => {
      row.value = this.$store.state.user.tag_settings[row.field]
      return row
    })
    this.showVehicleSettings = this.$route.name == 'map'
  }
}
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css">

</style>
